export const PLAYER_DAMAGE = Object.freeze({
  LIGHT: 0.25,
  STANDARD: 0.5,
  HEAVY: 0.75
})
